import inertiaPaths from '@config/inertia_paths.json'

// mirrors InertiaBoundary::SUBJECT_AREA
const SUBJECT_AREA = '/:subject_area'

interface Entry {
  path: string
  below: boolean
}

// mirrors InertiaBoundary.inertia_path?
export function isInertiaUrl(url: URL): boolean {
  if (url.origin !== window.location.origin) return false

  return entries().some(
    ({ path, below }) => url.pathname === path || (below && url.pathname.startsWith(`${path}/`)),
  )
}

// Unpoly follows a link's `up-href` instead of its `href`.
export function inertiaLinkSelectors(): string[] {
  return [
    ...inertiaUrlSelectors('a', 'href').map((selector) => `${selector}:not([up-href])`),
    ...inertiaUrlSelectors('a', 'up-href'),
  ]
}

export function inertiaFormSelectors(): string[] {
  return inertiaUrlSelectors('form', 'action')
}

function inertiaUrlSelectors(element: string, attribute: string): string[] {
  const { origin } = window.location
  return entries().flatMap(({ path, below }) =>
    [path, `${origin}${path}`].flatMap((base) => [
      `${element}[${attribute}="${base}"]`,
      ...[...(below ? ['/'] : []), '?', '#'].map(
        (separator) => `${element}[${attribute}^="${base}${separator}"]`,
      ),
    ]),
  )
}

function entries(): Entry[] {
  return [
    ...expand(inertiaPaths.prefixes).map((path) => ({ path, below: true })),
    ...expand(inertiaPaths.paths).map((path) => ({ path, below: false })),
  ]
}

function expand(paths: string[]): string[] {
  return paths.flatMap((path) =>
    path === SUBJECT_AREA || path.startsWith(`${SUBJECT_AREA}/`)
      ? subjectAreaPaths().map(
          (subjectAreaPath) => subjectAreaPath + path.slice(SUBJECT_AREA.length),
        )
      : [path],
  )
}

// Rendered by InertiaHelper#inertia_subject_area_paths_tag. Without it, the subject area entries match nothing and
// InertiaBoundary::Middleware sends those links across instead.
function subjectAreaPaths(): string[] {
  const content = document
    .querySelector('meta[name="sf-subject-area-paths"]')
    ?.getAttribute('content')
  if (!content) return []

  try {
    return JSON.parse(content) as string[]
  } catch {
    return []
  }
}
